import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IInsiderMembershipInformation) {
    (function(State) {
        State["STATE_UNKNOWN"] = "STATE_UNKNOWN";
        State["TRIALING"] = "TRIALING";
        State["ACTIVE"] = "ACTIVE";
        State["CANCELLED"] = "CANCELLED";
        State["UNPAID"] = "UNPAID";
        State["PAUSED"] = "PAUSED";
        /**
     * Excluded from insider due to experiment
     */ State["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
        /**
     * Eligible but have never had insider -- will purchase free trial first
     */ State["ELIGIBLE"] = "ELIGIBLE";
        State["AUTO_ENROLLED_TRIAL"] = "AUTO_ENROLLED_TRIAL";
    })(IInsiderMembershipInformation.State || (IInsiderMembershipInformation.State = {}));
    IInsiderMembershipInformation.build = function(partial) {
        return _object_spread({
            threshold_values: {}
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IInsiderMembershipInformation || (IInsiderMembershipInformation = {}));
export var IInsiderMembershipInformation;
